module.exports = __webpack_public_path__ + "img/img3.dd0f8fbd.png";